// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e5G79","colMin":"styles_colMin__YyAri"};